import { render, staticRenderFns } from "./T1.vue?vue&type=template&id=2d4e3e5f&scoped=true&"
import script from "./T1.vue?vue&type=script&lang=js&"
export * from "./T1.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4e3e5f",
  null
  
)

export default component.exports